import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeFeaturesSection from '../components/HomePage/sections/HomeFeaturesSection';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface FeaturesOverviewPageProps {
  onNavigate?: (view: string) => void;
}

const FeaturesOverviewPage: React.FC<FeaturesOverviewPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="features-overview"
      title={t('pages.features.seoTitle', 'AI Job Search Features | GoGrabJob')}
      description={t(
        'pages.features.seoDescription',
        'Explore GoGrabJob features: smart job matching, ATS resume optimization, interview prep, and an agentic career workspace.',
      )}
      canonical="https://www.gograbjob.com/features"
    >
      <HomeFeaturesSection onNavigate={onNavigate} />
    </MarketingPageShell>
  );
};

export default FeaturesOverviewPage;
